import { render } from "./AddToSlackButton.vue?vue&type=template&id=1bdaead7&scoped=true"
import script from "./AddToSlackButton.vue?vue&type=script&lang=js"
export * from "./AddToSlackButton.vue?vue&type=script&lang=js"

import "./AddToSlackButton.vue?vue&type=style&index=0&id=1bdaead7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdaead7"]])

export default __exports__